import type { WebPageEntity, SchemaRef } from '../core/types'

export function buildSchemaWebPage(options: {
  type?: string
  id?: string
  name?: string
  url?: string
  description?: string
  inLanguage?: string
  isPartOf?: SchemaRef
  primaryImageOfPage?: SchemaRef
  breadcrumb?: SchemaRef
  datePublished?: string
  dateModified?: string
}): WebPageEntity {
  return {
    '@type': options.type ?? 'WebPage',
    ...(options.id ? { '@id': options.id } : {}),
    ...(options.name ? { name: options.name } : {}),
    ...(options.url ? { url: options.url } : {}),
    ...(options.description ? { description: options.description } : {}),
    ...(options.inLanguage ? { inLanguage: options.inLanguage } : {}),
    ...(options.isPartOf ? { isPartOf: options.isPartOf } : {}),
    ...(options.primaryImageOfPage ? { primaryImageOfPage: options.primaryImageOfPage } : {}),
    ...(options.breadcrumb ? { breadcrumb: options.breadcrumb } : {}),
    ...(options.datePublished ? { datePublished: options.datePublished } : {}),
    ...(options.dateModified ? { dateModified: options.dateModified } : {})
  }
}
